import React from 'react';
import ProjectRoutes from './ProjectRoutes'; // Ensure correct path

function App() {

  return (
      <ProjectRoutes />

  );
}

export default App;